import * as numbers from "common/numbers";

// NB: We do not support 3 character hex at present
const isValidHex = (hex) =>
  hex == null || typeof hex !== "string"
    ? false
    : /^#?[A-Fa-f0-9]{6}$/.test(hex);

export const toRgb = (hex) => {
  if (!isValidHex(hex)) {
    return null;
  }
  const dec = (hex) => parseInt(hex, 16);
  const r = hex.substring(1, 3);
  const g = hex.substring(3, 5);
  const b = hex.substring(5, 7);
  return { r: dec(r), g: dec(g), b: dec(b) };
};

export const toHex = (r, g, b) => {
  if (
    !numbers.isFiniteNumber(r) ||
    !numbers.isFiniteNumber(g) ||
    !numbers.isFiniteNumber(b)
  ) {
    return null;
  }
  const hex = (value) => {
    value = numbers.clamp(value, 0, 255).toString(16);
    return "0".repeat(2 - value.length) + value;
  };
  return `#${hex(r)}${hex(g)}${hex(b)}`;
};

export const shades = (startColor, endColor, steps) => {
  if (!isValidHex(startColor) || !isValidHex(endColor) || steps <= 0) {
    return [];
  }

  if (steps === 1) {
    return [startColor];
  }

  const shades = [startColor];
  const start = toRgb(startColor);
  const end = toRgb(endColor);

  const rDeltas = numbers.distribute(end.r - start.r, steps - 1);
  const gDeltas = numbers.distribute(end.g - start.g, steps - 1);
  const bDeltas = numbers.distribute(end.b - start.b, steps - 1);

  let r = start.r;
  let g = start.g;
  let b = start.b;

  for (let i = 0; i < steps - 1; i++) {
    r += rDeltas[i];
    g += gDeltas[i];
    b += bDeltas[i];
    shades.push(toHex(r, g, b));
  }

  return shades;
};

export const lightenHex = (hex, fraction = 0.25) => {
  const rgb = toRgb(hex);
  if (!rgb) return hex;
  const mix = (channel) =>
    Math.round(channel + (255 - channel) * numbers.clamp(fraction, 0, 1));
  return toHex(mix(rgb.r), mix(rgb.g), mix(rgb.b));
};

export const hashToHue = (value) => {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash % 360);
};

export const parseHsl = (value) => {
  if (typeof value !== "string") {
    return null;
  }
  const match = value
    .trim()
    .match(/^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%/i);
  if (!match) {
    return null;
  }
  const [, h, s, l] = match;
  return {
    h: Number(h),
    s: Number(s),
    l: Number(l),
  };
};
